import React from "react";
import { Link } from "react-router-dom";

import { ReactComponent as LockIcon } from "../../../../../assets/MainPage/addBlock/lock.svg";
import { ReactComponent as TextIcon } from "../../../../../assets/MainPage/addBlock/text.svg";
import { ReactComponent as HeaderIcon } from "../../../../../assets/MainPage/addBlock/header.svg";
import { ReactComponent as LocationIcon } from "../../../../../assets/marker.svg";
import { ReactComponent as LinkIcon } from "../../../../../assets/MainPage/addBlock/link-2.svg";
import { ReactComponent as ShareIcon } from "../../../../../assets/MainPage/addBlock/ion_share-social-outline.svg";
import { ReactComponent as AvatarIcon } from "../../../../../assets/MainPage/addBlock/profile-circle.svg";
import { ReactComponent as QrIcon } from "../../../../../assets/MainPage/addBlock/scan-barcode.svg";
import { ReactComponent as FAQIcon } from "../../../../../assets/MainPage/addBlock/message-question.svg";
import { ReactComponent as YoutubeIcon } from "../../../../../assets/MainPage/addBlock/youtubeIcon.svg";
import { ReactComponent as InstaIcon } from "../../../../../assets/MainPage/addBlock/instaIcon.svg";
import { ReactComponent as TwitterIcon } from "../../../../../assets/MainPage/addBlock/twitter.svg";
import { ReactComponent as TiktokIcon } from "../../../../../assets/MainPage/addBlock/tikTokIcon.svg";
import { ReactComponent as ImageIcon } from "../../../../../assets/MainPage/addBlock/gallery.svg";
import { ReactComponent as ImageGridIcon } from "../../../../../assets/MainPage/addBlock/imageGrid.svg";
import { ReactComponent as DivideIcon } from "../../../../../assets/MainPage/addBlock/divider.svg";
import { ReactComponent as CountDownIcon } from "../../../../../assets/MainPage/addBlock/timer.svg";
import { useSelector } from "react-redux";
import useLocales from "../../../../../hooks/useLocales";

const MainCard = ({ icon: Icon, boxShadow, titleClasses, title, iconBg }) => {
  const { darkMode } = useSelector((state) => state.theme);

  return (
    <div
      className={`rounded-lg md:rounded-[10px] ${
        darkMode ? "" : "shadow-box_shadow_1"
      }  cursor-pointer bg-light_bg_v5 dark:bg-dark-secondary p-2 md:pr-[13px] flex items-center gap-2`}
    >
      <div className="p-[5px]">
        <div
          style={{
            boxShadow: boxShadow !== "" ? `-2px 3px 7px ${boxShadow}` : "",
          }}
          className={`p-[7px] rounded-lg ${iconBg}`}
        >
          <Icon />
        </div>
      </div>
      <div
        className={`text-small1 text-heading_color dark:text-color_v1_dark ${titleClasses}`}
      >
        {title}
      </div>
    </div>
  );
};

const AddBlockTabArea = () => {
  const { translate } = useLocales();

  const blockFeature = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.response
  );

  const paymenetBlocks = useSelector(
    (state) => state?.paymentStripes?.getBlockByPlanId?.paymenet_blocks
  );

  // Qr
  const qrCheck = blockFeature?.some(
    (item) => item?.name === "share" && paymenetBlocks === 1
  );
  // FAQ
  const faqCheck = blockFeature?.some(
    (item) => item?.name === "faq" && paymenetBlocks === 1
  );
  // Youtube
  const youtubeCheck = blockFeature?.some(
    (item) => item?.name === "youtube" && paymenetBlocks === 1
  );
  // Instagram
  const instagramCheck = blockFeature?.some(
    (item) => item?.name === "instagram" && paymenetBlocks === 1
  );
  // Twitter
  const twitterCheck = blockFeature?.some(
    (item) => item?.name === "twitter" && paymenetBlocks === 1
  );
  // Tiktok
  const tiktokCheck = blockFeature?.some(
    (item) => item?.name === "tiktok" && paymenetBlocks === 1
  );
  // Image
  const imageCheck = blockFeature?.some(
    (item) => item?.name === "image" && paymenetBlocks === 1
  );
  // Image Grid
  const imageGridCheck = blockFeature?.some(
    (item) => item?.name === "image_grid" && paymenetBlocks === 1
  );
  // Divider
  const dividerCheck = blockFeature?.some(
    (item) => item?.name === "divider" && paymenetBlocks === 1
  );
  // CountDown
  const countDownCheck = blockFeature?.some(
    (item) => item?.name === "countdown" && paymenetBlocks === 1
  );

  return (
    <>
      <div className="pt-10 px-6 md:px-0 ">
        <p className="text-small2 sm:text-small1 text-heading_color dark:text-color_v1_dark">
          {" "}
          {translate("addBlock.essentials")}{" "}
        </p>

        <div className="mt-[9px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 4xl:grid-cols-4 5xl:grid-cols-6 gap-3 sm:gap-[14px]">
          <Link to={"HeaderText"}>
            {/* <MainCard
            icon={(headingCheck && TextIcon) || LockIcon}
            boxShadow={(headingCheck && "#754A9144") || "#D3CECE"}
            iconBg={
              (headingCheck &&
                "bg-gradient-to-br from-[#754A91] to-[#54008A]") ||
              "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
            }
            title={"Heading"}
          /> */}
            <MainCard
              icon={HeaderIcon}
              boxShadow={"#"}
              iconBg={"bg-gradient-to-br from-[#6101FF] to-[#2F007D]"}
              title={translate("header_")}
            />
          </Link>

          <Link to={"links"}>
            {/* <MainCard
                  icon={(linkCheck && ShareIcon) || LockIcon}
                  boxShadow={(linkCheck && "#D4D60066") || "#D3CECE"}
                  iconBg={
                    (linkCheck &&
                      "bg-gradient-to-tl from-[#D4D600] to-[#005A5F]") ||
                    "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
                  }
                  title={"Links"}
                /> */}
            <MainCard
              icon={ShareIcon}
              boxShadow={"#D4D60066"}
              iconBg={"bg-gradient-to-tl from-[#D4D600] to-[#005A5F]"}
              title={translate("links")}
            />
          </Link>
          <Link to={"social"}>
            {/* <MainCard
                  icon={(socialCheck && LinkIcon) || LockIcon}
                  boxShadow={(socialCheck && "#832BC166") || "#D3CECE"}
                  iconBg={
                    (socialCheck &&
                      "bg-gradient-to-tl from-[#832BC1] to-[#F452FF]") ||
                    "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
                  }
                  title={"Socials"}
                /> */}
            <MainCard
              icon={LinkIcon}
              boxShadow={"#832BC166"}
              iconBg={"bg-gradient-to-tl from-[#832BC1] to-[#F452FF]"}
              title={translate("socials")}
            />
          </Link>
          <Link to={"avatar"}>
            {/* <MainCard
              icon={(avatarCheck && AvatarIcon) || LockIcon}
              boxShadow={(avatarCheck && "#FC6BA366") || "#D3CECE"}
              iconBg={
                (avatarCheck &&
                  "bg-gradient-to-br from-[#FC6BA3] to-[#DC3073]") ||
                "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
              }
              title={"Avatar"}
            /> */}
            <MainCard
              icon={AvatarIcon}
              boxShadow={"#FC6BA366"}
              iconBg={"bg-gradient-to-br from-[#FC6BA3] to-[#DC3073]"}
              title={translate("avatar")}
            />
          </Link>

          <Link to={"qrCode"}>
            <MainCard
              icon={(qrCheck && QrIcon) || LockIcon}
              boxShadow={(qrCheck && "#4D5CFF66") || "#D3CECE"}
              iconBg={
                (qrCheck &&
                  "bg-gradient-to-tl from-[#4D5CFF] from-10% via-[#5865F2] to-[#0088CC]") ||
                "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
              }
              title={translate("Qr_code")}
            />
          </Link>
          <Link to={"location"}>
            {/* <MainCard
            icon={(avatarCheck && AvatarIcon) || LockIcon}
            boxShadow={(avatarCheck && "#FC6BA366") || "#D3CECE"}
            iconBg={
              (avatarCheck &&
                "bg-gradient-to-br from-[#FC6BA3] to-[#DC3073]") ||
              "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
            }
            title={"location"}
          /> */}
            <MainCard
              icon={LocationIcon}
              boxShadow={"#"}
              iconBg={"bg-gradient-to-br from-[#0588A5] to-[#14D5FF]"}
              title={translate("cms.location")}
            />
          </Link>
        </div>
      </div>

      <div className="pt-10 px-6 md:px-0 ">
        <p className="text-small2 sm:text-small1 text-heading_color dark:text-color_v1_dark">
          {" "}
          {translate("addBlock.text")}{" "}
        </p>
        <div className="mt-[9px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 4xl:grid-cols-3 5xl:grid-cols-4 gap-3 sm:gap-[14px]">
          <Link to={"textEditor"}>
            {/* <MainCard
                icon={(headingCheck && TextIcon) || LockIcon}
                boxShadow={(headingCheck && "#754A9144") || "#D3CECE"}
                iconBg={
                  (headingCheck &&
                    "bg-gradient-to-br from-[#754A91] to-[#54008A]") ||
                  "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
                }
                title={"Heading"}
              /> */}
            <MainCard
              icon={TextIcon}
              boxShadow={"#754A9144"}
              iconBg={"bg-gradient-to-br from-[#754A91] to-[#54008A]"}
              title={translate("text_editor")}
            />
          </Link>
          <Link to={"faq"}>
            <MainCard
              icon={(faqCheck && FAQIcon) || LockIcon}
              boxShadow={(faqCheck && "#FF784255") || "#D3CECE"}
              iconBg={
                (faqCheck && "bg-gradient-to-tl from-[#EA4C0E] to-[#FF7842]") ||
                "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
              }
              title={translate("faq")}
            />
          </Link>
        </div>
      </div>

      <div className="pt-10 px-6 md:px-0 ">
        <p className="text-small2 sm:text-small1 text-heading_color dark:text-color_v1_dark">
          {translate("addBlock.media")}{" "}
        </p>
        <div className="mt-[9px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 4xl:grid-cols-4 5xl:grid-cols-6 gap-3 sm:gap-[14px]">
          <Link to={"media/youtube"}>
            <MainCard
              icon={(youtubeCheck && YoutubeIcon) || LockIcon}
              boxShadow={(youtubeCheck && "#DB050544") || "#D3CECE"}
              iconBg={
                (youtubeCheck &&
                  "bg-gradient-to-br from-[#DB0505] to-[#FF0000]") ||
                "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
              }
              title={translate("youtube")}
            />
          </Link>
          <Link to={"media/instagram"}>
            <MainCard
              icon={(instagramCheck && InstaIcon) || LockIcon}
              boxShadow={(instagramCheck && "#643DCE44") || "#D3CECE"}
              iconBg={
                (instagramCheck &&
                  "bg-gradient-to-br from-[#FCA759] from-3% via-[#E82D56] via-30% to-[#643DCE] to-18%") ||
                "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
              }
              title={translate("instagram")}
            />
          </Link>
          <Link to={"media/twitter"}>
            <MainCard
              icon={(twitterCheck && TwitterIcon) || LockIcon}
              boxShadow={(twitterCheck && "#0CA8F644") || "#D3CECE"}
              iconBg={
                (twitterCheck &&
                  "bg-gradient-to-b from-[#0CA8F6] to-[#0096E1]") ||
                "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
              }
              classes={"py-[1px]"}
              title={translate("twitter")}
            />
          </Link>
          <Link to={"media/tiktok"}>
            <MainCard
              icon={(tiktokCheck && TiktokIcon) || LockIcon}
              boxShadow={(tiktokCheck && "#32323266") || "#D3CECE"}
              iconBg={
                (tiktokCheck &&
                  "bg-gradient-to-br from-[#000000] to-[#323232]") ||
                "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
              }
              classes={"px-[1px]"}
              title={translate("tiktok")}
            />
          </Link>
          <Link to={"image"}>
            <MainCard
              icon={(imageCheck && ImageIcon) || LockIcon}
              boxShadow={(imageCheck && "#732ADF55") || "#D3CECE"}
              iconBg={
                (imageCheck &&
                  "bg-gradient-to-br from-[#732ADF] to-[#9146FF]") ||
                "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
              }
              title={translate("image")}
            />
          </Link>
          <Link to={"imageGrid"}>
            <MainCard
              icon={(imageGridCheck && ImageGridIcon) || LockIcon}
              boxShadow={(imageGridCheck && "#FF943655") || "#D3CECE"}
              iconBg={
                (imageGridCheck &&
                  "bg-gradient-to-t from-[#FF433A] to-[#FF9436]") ||
                "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
              }
              title={translate("image_grid")}
            />
          </Link>
        </div>
      </div>

      <div className="pt-10 mb-[50px] px-6 md:px-0 ">
        <p className="text-small2 sm:text-small1 text-heading_color dark:text-color_v1_dark">
          {translate("addBlock.miscellaneous")}
        </p>
        <div className="mt-[9px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 4xl:grid-cols-3 5xl:grid-cols-4 gap-3 sm:gap-[14px]">
          <Link to={"divider"}>
            <MainCard
              icon={(dividerCheck && DivideIcon) || LockIcon}
              boxShadow={(dividerCheck && "#36C30066") || "#D3CECE"}
              iconBg={
                (dividerCheck &&
                  "bg-gradient-to-b from-[#3ACE01] to-[#36C300]") ||
                "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
              }
              classes={""}
              title={translate("divider")}
            />
          </Link>
          <Link to={"countdown"}>
            <MainCard
              icon={(countDownCheck && CountDownIcon) || LockIcon}
              classes={"px-1 py-0.5"}
              boxShadow={(countDownCheck && "#CC060666") || "#D3CECE"}
              iconBg={
                (countDownCheck &&
                  "bg-gradient-to-t from-[#CC0606] to-[#FF0000]") ||
                "bg-gradient-to-tl from-[#BDBCBC] to-[#BDBCBC]"
              }
              title={translate("countdown")}
            />
          </Link>
        </div>
      </div>
    </>
  );
};

export default AddBlockTabArea;
